var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHollowStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5533 6.40762C18.3372 6.17674 18.042 6.02657 17.7204 5.98393V5.98329L12.6969 5.32246L10.709 0.798969C10.4187 0.136857 9.61975 -0.1758 8.92451 0.100623C8.59307 0.232413 8.32953 0.483337 8.19118 0.798969L6.20326 5.32246L1.17978 5.98329C0.431336 6.0825 -0.0909462 6.74077 0.0132335 7.4535C0.0580062 7.75979 0.2157 8.04093 0.458153 8.24665L4.24299 11.4607L3.46532 16.5042C3.38108 17.0163 3.62808 17.5266 4.09174 17.7982C4.54889 18.0766 5.1369 18.0662 5.58285 17.7718L9.45004 15.2674L13.3172 17.7744C13.9412 18.1777 14.7905 18.0229 15.214 17.4287C15.4065 17.1586 15.4853 16.8296 15.4348 16.5068L14.6572 11.4613L18.442 8.24725C19.0062 7.76853 19.056 6.94487 18.5533 6.40762ZM13.4867 10.735C13.3173 10.879 13.2354 11.0945 13.2686 11.3084L14.0786 16.708L9.83144 13.9581C9.60247 13.8099 9.30168 13.8099 9.07271 13.9581L4.80052 16.6913L5.63146 11.3058C5.66373 11.0928 5.58186 10.8785 5.41341 10.735L1.3633 7.25862L6.76885 6.5483C7.00553 6.51723 7.20729 6.36932 7.2994 6.15941L9.45811 1.2856C9.46056 1.28846 9.46238 1.29174 9.46352 1.29524L11.6 6.15685C11.6921 6.36676 11.8939 6.51467 12.1305 6.54574L17.5428 7.28755L13.4867 10.735Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHollowStar);
export default __webpack_public_path__ + "static/media/hollowStar.85026bca0f1dc370fa2d325d54604eef.svg";
export { ForwardRef as ReactComponent };